import React from 'react';
import './HowWeWork.css';

function HowWeWork() {
  return (
    <div className="how-we-work-section">
      <div className="container">
        <div className="how-we-work-grid">
          <div className="how-we-work-text">
            <h2 className="how-we-work-title">Gestión Patrimonial e Inversión Inmobiliaria</h2>
            <p className="how-we-work-paragraph">
              TABIA es un grupo patrimonial y empresarial diversificado, con un enfoque principal —aunque no exclusivo— en el sector inmobiliario. Nacido en las Islas Baleares, España, el grupo opera con una clara vocación internacional.
            </p>
            <p className="how-we-work-paragraph">
              Además de su actividad inversora, TABIA ofrece servicios especializados a través de sus compañías filiales, centradas en la gestión patrimonial inmobiliaria (TABIA Gestión) y en la identificación y estructuración de oportunidades de inversión inmobiliaria (TABIA Inmobiliaria).
            </p>
            <p className="how-we-work-paragraph">
              Actualmente, el grupo gestiona un patrimonio inmobiliario valorado en más de 390 millones de euros, reflejo de su capacidad para diseñar soluciones integrales, estratégicas y alineadas con los intereses de clientes e inversores.
            </p>
          </div>
          <div className="how-we-work-image">
            <img src={`${process.env.PUBLIC_URL}/how-we-work.jpg`} alt="How we work" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowWeWork;
